import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

export const Container = styled.div`
  width: 420px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 10px -6px #252525;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  gap: 10px;
  border-radius: 16px;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  margin-right: 10px;
  gap: 15px;
`

export const FormField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #000000;
`

export const SubTitle = styled(InfoText)`
  width: 100%;
  font-weight: bold;
  text-align: left;
  padding: 15px 20px;
  cursor: pointer;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`
